module.exports = __webpack_public_path__ + "img/timeline.jpg";